import { render, staticRenderFns } from "./ComponentTree.vue?vue&type=template&id=515ebaf3&scoped=true&"
import script from "./ComponentTree.vue?vue&type=script&lang=js&"
export * from "./ComponentTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515ebaf3",
  null
  
)

export default component.exports